export default __webpack_public_path__ + "static/works-image1-51edad03e1813f35caaff8beca61fe5d.jpg";